import React, { useEffect, useContext, useState } from 'react';
import { LoginContext } from '../../hooks/context/LoginContext';
import axios from 'axios';
import Menusup from '../../componentes/menus/menusup/Menusup';
import Sidebar from '../../componentes/menus/sidebar/Sidebar';
import Footer from '../../componentes/footer/Footer';
import Section from '../../componentes/ui/Section';
import PermissionRefused from '../../componentes/ui/PermissionRefused';
import LoadingPage from '../../componentes/ui/LoadingPage';
import ButtonOutline from '../../componentes/ui/ButtonOutline';
import MiSelect from '../../componentes/formulario/MiSelect';
import swal from 'sweetalert';
import Spinner from 'react-bootstrap/Spinner';
import useLogicForm from '../../hooks/useLogicForm';
import Cookies from 'universal-cookie';
import { MiReplaceAll, getApiUrl, stringToHtml, axiosPost, getTitle, encryptData, getDecodedCookie } from '../../helpers/helperApp';
import { Fragment } from 'react';
import FormRow from '../../componentes/formulario/FormRow';

function ImpAuto(props){

    const cookies = new Cookies();
    const CancelToken = axios.CancelToken;
    const source = CancelToken.source();

    // ***** Context *****
    const { validateSesion, socket, confApp, saveConfApp, getConfApp, apiKey, appCryptCom } = useContext(LoginContext);    

    // ***** State para la configuración de la pantalla *****
    const [ confPantalla, saveConfPantalla ] = useState(confApp)
    const [ loadedConf, saveLoadedConf ] = useState(false);
    const [ tieneNivel, saveTieneNivel ] = useState(true);
    const [ respuestaImp, saveRespuestaImp ] = useState("");
    const [ loading, saveLoading ] = useState(false);

    useEffect( () => {        
        
        // ***** Validamos que el usuario esté logueado sino lo enviamos al login*****
        validateSesion(props)
            .then( (respuesta) => {
                if( confPantalla === undefined ){
                    return getConfApp();
                }else{ 
                    document.title = getTitle(confPantalla.config.trad, confApp.impauto.section.titulo);
                    if( getDecodedCookie('nivel') == 1 || getDecodedCookie('nivel') == 2 || getDecodedCookie('nivel') == 3 ){
                        if( respuesta == 1 ){
                            saveTieneNivel(true);                                                                            
                        }
                        else if( respuesta == 0 ){
                            saveTieneNivel(false);
                        }
                    }else{
                        saveTieneNivel(false);
                    }                                        

                    saveLoadedConf(true);
                }
            })
            .then( (respuesta) => {
                if( respuesta !== undefined  ){
                    saveConfPantalla(respuesta.msg);
                    saveConfApp(respuesta.msg);             
                }
            })          

        // Liberamos todos los registros al salir de la pantalla
        return () =>{
            if( socket != null ){
                socket.emit("salirPantalla", { "idusu": getDecodedCookie('id'), "tabla": "undefined" })
            }
                document.querySelector("body").classList.remove("sidebar-open");

                let input = document.getElementById('inputAuto');
                if( input ){
                    input.remove();
                }
                
                // Token cancelación axios al desmontar componentes
                source.cancel();
        } 

    },[confPantalla, respuestaImp])
    

    const importFn = () => {                

        let inputFile;        
        if( !document.getElementById('inputAuto') ){
            inputFile = document.createElement('input');
            inputFile.setAttribute('id','inputAuto');
            inputFile.setAttribute('type','file');
            inputFile.style.display = 'none';
            // inputFile.setAttribute('accept','.csv, .xls, .xlsx ');
            inputFile.setAttribute('enctype','multipart/form-data');
            document.body.appendChild(inputFile);            
        }else{
            inputFile = document.getElementById('inputAuto')
        }
        
        inputFile.addEventListener('change', handleFileImportAuto, false);
        inputFile.click(); 
        
    }

    const handleFileImportAuto = async () => {        
        let inputFile = document.getElementById('inputAuto');          
        const file_data = inputFile.files[0];
        //Validamos la extensión        
        if( !validateExtension(file_data, ['csv','xls','xlsx']) ){
            if( file_data ){
                swal("Error", `${file_data["name"]} ${confPantalla.config.trad.components.importador.errorfiletype.title}`, "error");                   
            }
        }else{
            saveLoading(true); 
            
            saveRespuestaImp("");

            let data = new FormData();                  
            data.append('file', file_data);
            data.append('tabimp', "impauto");            
            data.append("validacion", apiKey());  
    
            const url = `${getApiUrl(window.location.origin)}/app/FileToDB`;
            // const res = await axios.post(url, data); 
            const res = await axiosPost(url, data, source.token);   

            saveRespuestaImp(res.data);
        }
        // document.getElementById('inputAuto').value = "";     
        saveLoading(false);                               
   
    }

    const validateExtension = (file, extensiones) => {
        if( file ){
            let fileExtension = file["name"].split(".")[file["name"].split(".").length-1];
            const valido = extensiones.find(ext => fileExtension.toLowerCase() == ext.toLowerCase());
            return valido;
        }
    }

    return(
        <div className="App wrapper">   
        {
            confPantalla !== undefined
            ?
                <Fragment>
                    <Menusup 
                        props = { props }
                    />
                    <Sidebar 
                        props = { props }
                    />
                </Fragment>
            :
            null
        } 
        <div className="content-wrapper">
            <div className="content-header">
            </div>
            <section className="content">
                {
                    !tieneNivel 
                    ?
                        <PermissionRefused
                            traduction={confPantalla.config.trad.components.permissionrefused} 
                        />
                    :
                    <Fragment>
                    {
                        loadedConf === true && confPantalla !== undefined
                        ?
                            <Section 
                                    titulo={confApp.impauto.section.titulo} 
                                    icono={confApp.impauto.section.icono} 
                                    col={confApp.impauto.section.col} 
                                    wiki={confApp.impauto.section.wiki}                                    
                            >
                            <div className="card">
                                <div className="card-header">
                                    <i className="fal fa-info-circle fa-2x" style={{color: "#212529"}}></i>
                                </div>
                                <div className="card-body">
                                    <blockquote className="blockquote mb-0" style={{borderLeft : "none"}}>
                                        <p>{confApp.impauto.blockquote.titulo}</p>
                                        <footer className="blockquote-footer">
                                            <cite>
                                                <a className='ml-1' href={"https://drive.google.com/drive/folders/1rJSVPKd9ejmEqDoRgg6YDrA597XIzVX5?usp=drive_link"} target='_blank'>
                                                    {confApp.impauto.blockquote.a.titulo}
                                                </a>
                                            </cite>
                                        </footer>
                                    </blockquote>                                    
                                </div>
                            </div>                            
                            <ButtonOutline
                                clases={ "col-12 mt-2" }
                                color={ "success" } 
                                type="button" 
                                icono={ "mr-1 fal fa-file-upload" }   
                                id=""     
                                texto={confApp.impauto.btnupload.titulo}   
                                accion={ importFn } 
                                disabled={ false }
                            />
                            {
                                loading ?
                                    <div className='mt-3 text-center'>
                                        <Spinner animation="border" />
                                    </div>                                 
                                :
                                    null
                            }
                            {
                                respuestaImp != "" ?
                                    <div className='mt-4'>
                                        <div className="alert alert-success" role="alert" 
                                             dangerouslySetInnerHTML={stringToHtml(respuestaImp)}
                                        >
                                        </div>
                                    </div>
                                :
                                    null
                            }
    
                                                                
                            </Section>
                        :
                            <LoadingPage />
                        }
                    </Fragment>
                }
                
            </section>
        </div>
        <Footer />        
        </div>

    );

}
export default ImpAuto